module.exports = __webpack_public_path__ + "components/breakheader/background/background--9-e0ea19b34db1ee64753ddc77b9e3ffb3.jpg";